<template>
  <div class="menuBody" style="margin-left:25px;width:100%">
    <div class="menuTool">
      <el-card class="box-card">
        <el-row :gutter="24">
          <div class="iconToolTop">
            <div>
              <el-button type="primary" size="mini" @click="getAllMenu('web')">web菜单</el-button>
              <el-button type="primary" size="mini" @click="getAllMenu('app')">app菜单</el-button>
            </div>
            <el-button type="primary" size="mini"  plain v-Jurisdiction="'sys:web:menu:manage:add'"  @click="menuAdd()">添加菜单</el-button>
          </div>
      <el-table tooltip-effect="light"  :data="menuTree" v-loading="loading"  height="450" row-key="id" style="margoin-top:20px" border :default-expand-all="false" :stripe="true"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column show-overflow-tooltip prop="name" label="名称"  ></el-table-column>
      <el-table-column show-overflow-tooltip prop="href" label="链接"  ></el-table-column>
      <el-table-column show-overflow-tooltip prop="sort" label="排序" sortable  align="center"></el-table-column>
      <el-table-column show-overflow-tooltip prop="isShow" label="可见"   align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isShow === '1' ? 'success' : 'warning'"
                  disable-transitions>{{ scope.row.isShow === '1' ? '显示' : '不显示' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="isLog" label="日志"   align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isLog === '1' ? 'success' : 'warning'"
                  disable-transitions>{{ scope.row.isLog === '1' ? '保存' : '不保存' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="permission" label="权限标识"  align="center"></el-table-column>
      <el-table-column width="200" label="操作" align="center" >
        <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small"
          v-Jurisdiction="'sys:web:menu:manage:edit'"
                     title="修改"></el-button>
          <el-button @click="addNextMenu(scope.row)" type="success"  icon="el-icon-plus"  circle
          v-Jurisdiction="'sys:web:menu:manage:add'"
                     size="small" title="添加下级菜单"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small"
          v-Jurisdiction="'sys:web:menu:manage:del'"
                     title="删除"  v-debounce></el-button>
<!--          <el-button @click="selectMenuRole(scope.row)"  type="info" icon="el-icon-s-custom" circle size="small"-->
  <!-- v-Jurisdiction="'sys:web:menu:manage:getRole'" -->
<!--                     title="查看角色"></el-button>-->
        </template>
      </el-table-column>
    </el-table>
        </el-row>
      </el-card>
    </div>
   <MenuManagementDialog @dialog="dialog" ref="MenuManagementDialog"/>
  </div>
</template>

<script>
import MenuManagementDialog from "./MenuManagementDialog.vue";

export default {
  name: "MenuManagement",
  components: {MenuManagementDialog},
  data() {
    return {
      loading:false,
      menuTree: [],
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
    }
  },
  methods: {
    getAllMenu(type) {
            let obj = {
           "delFlag": "",
           "menuType": type,
           "isShow": ""
       }
      this.$http.post(this.$requestUrl.GET_ALL_MENU,obj).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          if(result.data==null){
            this.loading = false
          }else{
            this.loading = false
          for(let val of result.data){
            val.label = val.name
            val.value = val.id
            if(val.children.length !=0){
              this.circulation(val.children)
            }
          }
        this.menuTree = result.data;
          }
        } else {
          this.loading = false
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.loading = false
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    circulation(children){
         for(let res of children){
                  res.label = res.name
                  res.value = res.id
                  if(res.children.length!=0){
                    this.circulation(res.children)
                  }
        }
    },
    dialog(data){
      if(data == false){
        this.getAllMenu('0')
      }
    },
    menuInfo(row) {
    },
    menuAdd(){ // 添加菜单
      this.$refs.MenuManagementDialog.title = "添加";
      this.$refs.MenuManagementDialog.dialogVisible = true; 
      this.$refs.MenuManagementDialog.menuTree = this.menuTree; 
    },
    editMenu(row) { // 修改
      let arr = []
    if(row.parentId==""){
       arr.push(row.id)
    }else{
      arr.push(row.parentId)
      arr.push(row.id)
    }
      this.$refs.MenuManagementDialog.title = "修改";
      this.$refs.MenuManagementDialog.dialogVisible = true; 
      this.$refs.MenuManagementDialog.value = row.parentId
      this.$refs.MenuManagementDialog.display = row.isShow
      this.$refs.MenuManagementDialog.log = row.isLog 
      this.$refs.MenuManagementDialog.optvalue = row.icon
      this.$refs.MenuManagementDialog.formLabelAlign = row
      this.$refs.MenuManagementDialog.parentId = row.parentId
      this.$refs.MenuManagementDialog.display = row.isShow
      this.$refs.MenuManagementDialog.IconinputS = row.icon
    },
    addNextMenu(row) { // 添加下级菜单
      let arr = []
    if(row.parentId==""){
       arr.push(row.id)
    }else{
      arr.push(row.parentId)
      arr.push(row.id)
    }
    this.$refs.MenuManagementDialog.title = "添加下级菜单";
    this.$refs.MenuManagementDialog.dialogVisible = true; 
    this.$refs.MenuManagementDialog.value = arr
    this.$refs.MenuManagementDialog.parentId = row.id
    },
    delMenu(row) { // 删除
          this.$confirm('您确认要删除当前菜单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
      this.$http.delete(this.$requestUrl.DELETE_MENU+row.id).then((res)=>{
       let result = res.data;
        if (200 === result.code) {
           this.getAllMenu()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    selectMenuRole(row) { // 查看角色
    let PageSize = {
      "id":row.id,
      "page":1,
      "size":20,
    }
    this.$http.post(this.$requestUrl.POST_MENUROLE,PageSize).then((res)=>{
      if(res.data.code == 200){
        this.$refs.MenuManagementDialog.title = "查看";
        this.$refs.MenuManagementDialog.dialogVisible = true; 
        this.$refs.MenuManagementDialog.tableData = res.data.data.records; 
      }
    })
    }
  },
  mounted() {
    this.getAllMenu('0');
  }
}
</script>

<style lang="scss">
 
.menuBody {
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
       
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }
  .iconToolTop{
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

}
</style>